import { useEffect, useState } from "react";
import { espaceApi, CLE_JETON } from "../espace/api";

/* La famille connectée à son espace, si elle l'est. Les formulaires d'inscription s'en
   servent pour se remplir tout seuls : un parent qui vient de l'application n'a pas à
   retaper son adresse, son téléphone ni la date de naissance de ses enfants.
   Personne de connecté : rien ne change, le formulaire reste vide. */
export function useFamilleConnectee() {
  const [moi, setMoi] = useState(null);
  useEffect(() => {
    let jeton = "";
    try { jeton = localStorage.getItem(CLE_JETON) || ""; } catch { /* navigation privée */ }
    if (!jeton) return undefined;
    let actif = true;
    espaceApi.get("/moi")
      .then(({ data }) => { if (actif && data?.rattachee) setMoi(data); })
      .catch(() => { /* session expirée : formulaire vide, comme avant */ });
    return () => { actif = false; };
  }, []);
  return moi;
}

/** Les champs « responsable » d'un formulaire, remplis depuis la fiche de la famille. */
export const coordonneesDe = (moi) => {
  const [prenom, ...reste] = String(moi?.responsable || "").split(" ");
  return {
    prenom: moi?.prenom_responsable || prenom || "",
    nom: moi?.nom_responsable || reste.join(" ") || "",
    email: moi?.email || "",
    telephone: moi?.telephone || "",
    adresse: moi?.adresse || "",
    npa: moi?.npa || "",
    localite: moi?.localite || "",
  };
};
